import React, { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import EndPoints from "src/Constants/EndPoints";
import CSS from "csstype";
import { useTranslation } from "react-i18next";

function PostModal(props: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const {
    showModal,
    setModalVisibility,
    postData,
    setPostData,
    groupId: gId,
    refetch
  } = props;

  const { id, message: msg = "", images: imgs = [], groupId = gId } = postData;
  const [message, setMessage] = useState(msg);
  const [messageError, setMessageError] = useState("");
  const [imgBtnText, setImgBtnText] = useState(
    imgs && imgs.length ? `${t("Photos")} (${imgs.length})`:t("Add Photo")
  ); 
  const [images, setImages] = useState<any>([]);
  const [imageUrls, setImageUrls] = useState<any>(imgs);
  const [deleteImgs, setDeleteImgs] = useState<any>([]);
  const imageField: CSS.Properties = {
    width: "1",
    height: "1",
    opacity: "0",
    position: "absolute",
    overflow: "hidden",
    zIndex: -1,
  };

  const imgPreview: CSS.Properties = {
    width: "100%",
    height: "200px",
  };

  const crossIcon: CSS.Properties = {
    color: "#e01515",
    position: "absolute",
    right: "-2px",
    fontSize: "20px",
    cursor: "pointer",
    top: "-5px",
  };


  // textarea
  const MIN_HEIGHT = 51;
  const MAX_HEIGHT = 450;
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  React.useLayoutEffect(() => {
    if (textareaRef.current !== null && textareaRef.current?.scrollHeight < MAX_HEIGHT){
        textareaRef.current.style.height = "inherit";
        textareaRef.current.style.height = `${Math.max(
        textareaRef.current.scrollHeight,
        MIN_HEIGHT
        )}px`;
    }
  }, [message]);
  // textarea


  const [createPost, { status }] = useApiMutation({
    onSuccess: () => {
      setModalVisibility(false);
      setPostData([]);
      refetch && refetch();
    },
  });

  const handleCreatePost = async () => {
    console.log('props ', props);
    console.log('message ', message);
    console.log('status ', status);
    if (status === "loading") {
      return;
    }
    if (message.trim() === ""  && images.length === 0 && imageUrls.length === 0) {
      setMessageError(t("Post is required"))
      return;
    }
    const url = groupId
      ? id
        ? EndPoints.updateGroupPost
        : EndPoints.createGroupPost
      : id
        ? EndPoints.updatePost
        : EndPoints.createPost;
    try {
      await createPost({
        url: url,
        data: {
          postId: id,
          groupId: groupId,
          subId: user?.username,
          message: message,
          images: images,
          delete_images: deleteImgs,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageRemove = (index: number, id: number) => {
    if (id) {
      setDeleteImgs([...deleteImgs, id]);
    }
    imageUrls.splice(index, 1);
    images.splice(index, 1);
    setImages(images);
    setImageUrls(imageUrls);
    setImgBtnText("Photos (" + imageUrls.length + ")");
  };

  const fileSelectedHandler = async (imgs: any) => {
    const imgsArr = images;
    const urlsArr = imageUrls;
    for (const image of imgs) {
      const base64 = await convertImagesToBase64(image);
      imgsArr.push(base64);
      urlsArr.push({ url: URL.createObjectURL(image) });
    }
    setImages(imgsArr);
    setImageUrls(urlsArr);
    setImgBtnText("Photos (" + urlsArr.length + ")");
  };

  const convertImagesToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        resolve(fileReader.result);
      };
      fileReader.onerror = function (error) {
        console.log("Error: ", error);
        reject(error);
      };
    });
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(false);
    if (setPostData && typeof setPostData === "function") {
      setPostData([]);
    }
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label className="mb-0">
                      {id ? t("Edit Post") : t("Post a message")}
                    </label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label>{t("Message")}</label>
                    <textarea
                      value={message}
                      ref = {textareaRef}
                      style={{minHeight:MIN_HEIGHT, maxHeight:MAX_HEIGHT, resize: "none"}}
                      id="msgId"
                      className="form-control"
                      placeholder={t("Write a message")}
                      onChange={(e) => {setMessage(e.target.value); (e.target.value.length == 0 && images.length === 0 && imageUrls.length === 0) ? setMessageError(t("Post is required")) : setMessageError("")}}
                    ></textarea>
                    {messageError &&
                      <p className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} style={{color: "red", fontSize: "10px", paddingTop : "50"}}> {messageError} </p> }
                  </div>
                  <div className="d-sm-flex justify-content-between">
                    <div className="mb-3 mb-sm-0">
                      <label htmlFor="photos" className="mb-0">
                        <p className="d-inline-block btn custom_btn rounded text-secondary bg-transparent border fz15 mb-0">
                          <i
                            className={`fa fa-camera base_color fz18 ${i18n.dir()=== 'rtl'? "ml-3" : "mr-3"}`}
                            aria-hidden="true"
                          ></i>
                          {imgBtnText}
                        </p>
                      </label>
                      <input
                        id="photos"
                        style={imageField}
                        type="file"
                        accept="image/*"
                        multiple={true}
                        onChange={(e) => fileSelectedHandler(e.target.files)}
                      />
                    </div>
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir() === 'rtl' ? 'ml-3' : 'mr-3'}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        type="button"
                        className="btn custom_btn fz14"
                        onClick={() => handleCreatePost()}
                      >
                        <VisibilityToggle visible={status === "loading"}>
                          <span className="spinner-border spinner-border-sm"></span>
                        </VisibilityToggle>
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
                <VisibilityToggle visible={imageUrls.length !== 0}>
                  <div className="row mt-3">
                    {imageUrls.map((img: any, i: number) => {
                      return (
                        <div key={i} className="col-md-6">
                          <div style={{ position: "relative" }}>
                            <img
                              key={i}
                              style={imgPreview}
                              alt="London"
                              src={img.url}
                              className="object_fit mb-3"
                            ></img>
                            <i
                              key={i + "cross"}
                              style={crossIcon}
                              className="fa fa-times-circle base_color"
                              aria-hidden="true"
                              onClick={() => handleImageRemove(i, img.id)}
                            ></i>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </VisibilityToggle>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default PostModal;
